<template>
  <div class="filter-menu-container">
    <div class="contentContainer">
      <span class="title">{{title+':'}}</span>
      <div class="list-container" :class="{showMore:isShowMore}">
        <ul class="list" ref="contentlist">
          <li
            ref="listItem"
            v-for="(item,index) in filtersContent"
            :key="index"
            @click="clickItem(item,index)"
          >
            <div itemDiv>
              <span :class="{activeStyle:item==selectedItem}">{{item[displayName]}}</span>
            </div>
            <div class="subscript" v-if="item.cornerMarkType">
              <div v-if="item.cornerMarkType==1">NEW</div>
              <div v-if="item.cornerMarkType==2">上新</div>
            </div>
          </li>
        </ul>
        <!-- <div class="mask"></div> -->
      </div>

      <div v-if="isShowMoreBtn" class="more-btn-container" @click="showMore">
        <span class="more-btn">{{isShowMore?"收起":"更多"}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "filterMenu",
  model: {
    prop: "selectedItem",
    event: "selected"
  },
  data() {
    return {
      isShowMore: false,
      isShowMoreBtn: false
    };
  },
  props: {
    title: "",
    displayName: "",
    filtersContent: Array,
    openShowMoreBtn: false,
    selectedItem: Object
  },
  components: {},
  methods: {
    clickItem(item, index) {
      this.$emit("selected", item);
      //this.$emit("selectChanged", item);
    },
    showMore: function() {
      this.isShowMore = !this.isShowMore;
    }
  },
  watch: {
    selectedItem: function(val, oldval) {
      this.$emit("selectChanged", { newValue: val, oldValue: oldval });
    }
  },
  computed: {},
  mounted() {
    //this.setDefaultActive();

    var MutationObserver =
      window.MutationObserver ||
      window.webkitMutationObserver ||
      window.MozMutationObserver;

    let ul = this.$refs.contentlist;
    var recordHeight = 0;
    var mutationObserver = new MutationObserver(mutations => {
      let height = parseInt(
        window.getComputedStyle(ul).getPropertyValue("height")
      );
      if (height > 51) {
        this.isShowMoreBtn = true;
      } else {
        this.isShowMoreBtn = false;
      }
      //console.log(this.isShowMoreBtn);
    });

    mutationObserver.observe(ul, {
      childList: true, // 子节点的变动（新增、删除或者更改）
      attributes: true, // 属性的变动
      characterData: true, // 节点内容或节点文本的变动
      subtree: true // 是否将观察器应用于该节点的所有后代节点
    });
  }
};
</script>

<style scoped lang="scss">
.filter-menu-container {
  position: relative;
  width: auto;
  /* height: 24px; */
  margin: 0px;
}

.activeStyle {
  color: #5778fb;
}

.contentContainer {
  display: flex;
  flex-wrap: nowrap;
  align-content: flex-start;
  align-items: flex-start;
}

.title {
  white-space: nowrap;
  font-size: 12px;
  color: #333333;
  text-align: left;
  font-weight: bold;
  margin-top: 12px;
  padding: 0;
  height: 20px;
}

.list-container {
  position: relative;
  width: auto;
  /* height: 20px; */
  margin: 0px;
  max-height: 27.5px;
  overflow: hidden;

  transition: max-height 0.4s ease;
}

// .list-container::-webkit-scrollbar {
//   display: none;
//   /* width: 0;
//   background-color: #fff; */
// }

.showMore {
  overflow: auto;
  max-height: 200px;
  &::-webkit-scrollbar {
    width: 6px;
    height: 8px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dee9;
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #bdbdbe;
  }
  & > .list {
    width: 100%;
  }
}
.no-scroll .showMore {
  overflow: hidden;
}

.mask {
  height: 100%;
  width: 100%;
  margin-top: 20px;
  background-color: #fff;
}
.list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
  margin-left: -5px;
}

.list li {
  font-size: 12px;
  color: #474261;
  /* height: 14px; */
  padding: 0 20px;
  border-left: 2px solid #f8f8f8;
  margin-top: 12px;
  box-sizing: content-box;
  position: relative;
  .subscript {
    position: absolute;
    width: 0px;
    height: 0px;
    right: 0px;
    top: 0px;
    div {
      float: right;
      position: absolute;
      margin-left: -30px;
      margin-top: -10px;
      width: 34px;
      height: 16px;
      border-radius: 8px 4px 8px 0px;
      background-color: #ff4049;
      color: #ffffff;
      transform: scale(0.7);
      z-index: 50;
    }
  }
}

.list li:hover {
  cursor: pointer;
}

.list li span {
  display: inline-block;
}

/* .list li:last-child {
  border: none;
} */

.more-btn-container {
  position: relative;
  min-width: 50px;
  height: 14px;
  margin-left: 70px;
}

.more-btn {
  position: absolute;
  white-space: nowrap;
  font-size: 12px;
  color: #474261;
  text-align: left;
  font-weight: bold;
  padding: 0;
  height: 14px;
  top: 12px;
  right: 20px;
}

.more-btn:after {
  content: "";
  width: 8px;
  height: 8px;
  border-bottom: 1px solid #474261;
  border-right: 1px solid #474261;
  position: absolute;
  margin-left: 5px;
  margin-top: 2px;
  transform-origin: center center;
  transform: rotate(45deg);
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/templateLib/filterMenu.vue